// extracted by mini-css-extract-plugin
export default {"ace-c-document-upload-panel":"document-upload-panel---1d3711ce"};